/**
 * @generated SignedSource<<92a24341f048eda71515297a41879227>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TextRecord_content$data = {
  readonly id: string;
  readonly text: string | null | undefined;
  readonly " $fragmentType": "TextRecord_content";
};
export type TextRecord_content$key = {
  readonly " $data"?: TextRecord_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"TextRecord_content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TextRecord_content",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "type": "TextRecord",
  "abstractKey": null
};

(node as any).hash = "bc21ff2ab6a19e455642c96dbdac3d3e";

export default node;
